<template>
  <div>
    <!-- User Interface controls -->
    <b-row>
      <b-col md="7" class="my-1">
        <b-form-group class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="5" class="my-1">
        <b-form-group label-cols-md="4" label="Per page" class="mb-0">
          <b-form-select :options="pageOptions" v-model="perPage" />
        </b-form-group>
      </b-col>
    </b-row>
  <b-row v-if="warn == true && role == 'student'">
    <b-col md="12">
      <b-alert variant="warning" show>A yellow box around the Assessed Date indicates you have not confirmed viewing the evaluation.</b-alert>
    </b-col>
  </b-row>
    <!-- Main table element -->
    <b-table show-empty empty-text="Please wait while the competencies load." striped small responsive stacked="md"
      caption-top :items="items" :current-page="currentPage" :per-page="perPage" :fields="fields" :filter="filter"
      @filtered="onFiltered" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc">
      <template v-slot:cell(competency)="row">
            {{ row.item.title }}
        <div>
          <small>{{ row.item.category }}</small>
        </div>
      </template>
      <template #head(user)>
        <div v-if="role == 'preceptor'">Student</div>
        <div v-else>Preceptor</div>
      </template>
      <template v-slot:cell(user)="row">
        <div v-if="role == 'preceptor'">{{ row.item.user.name }}</div>
        <div v-else>{{ row.item.preceptor_name }}</div>
      </template>
      <template v-slot:cell(date)="row">
        <div v-if="row.item.student_viewed == false" class="bg-warning text-dark p-1">
          <div class="d-none">
            {{ warn = true }}
          </div>
          <div>
            <small>Performed: {{ row.item.date }}</small>
          </div>
          <div>
            <small>Assessed: {{ row.item.assessed_date }}</small>
          </div>
          <div>
            <small>Not yet confirmed.</small>
          </div>
        </div>
        <div v-else>
          <div>
            <small>Performed: {{ row.item.date }}</small>
          </div>
          <div>
            <small>Assessed: {{ row.item.assessed_date }}</small>
          </div>          
          <div>
            <small>Confirmed: {{ row.item.viewed_date }}</small>
          </div>
        </div>
      </template>
      <template v-slot:cell(pass)="row">
        <div>
          <small v-if="row.item.attitude == 3">
          <i class="em em-smiley"></i>
          </small>
          <small v-if="row.item.attitude == 2">
            <i class="em em-neutral_face"></i>
          </small>
          <small v-if="row.item.attitude == 1">
            <i class="em em-unamused"></i>
          </small>
        </div>
        <div v-if="row.item.from_pcr == true">
          <small class="text-warning">From PCR/CR</small>
        </div>
        <small v-if="row.item.pass == true">Successful</small>
        <small v-else class="text-danger">Unsuccessful</small>
      </template>
      <template v-slot:cell(actions)="row" class="text-nowrap">
        <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
        <b-button @click.stop="row.toggleDetails" class="btn btn-success mb-2">                  
          <span class="icon icon-info"></span>
        </b-button>
        <b-button-group class="mb-2">
          <b-button class="btn btn-warning" v-if="row.item.preceptor_id == user.id" @click.stop="editComp(row.item.id)">
            <span class="icon icon-pencil"></span></b-button>
            <b-button variant="success" @click.stop="viewComp(row.item.id)">
            <span class="icon icon-eye"></span></b-button>
        </b-button-group>
      </template>
      <template v-slot:row-details="row">
        <b-card>
          <div class="font-weight-bold mb-3">{{ row.item.title }}</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr>
                <td>
                  <span class="font-weight-bold">Task</span>
                </td>
                <td>
                  {{ row.item.task }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="font-weight-bold">Performance Objectives</span>
                </td>
                <td>
                  {{ row.item.objectives }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="font-weight-bold">Directions to Candidate</span>
                </td>
                <td>
                  <div v-html="row.item.description"></div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Steps</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr v-for="(step, index) in row.item.steps" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-html="step"></td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="font-weight-bold mb-3">Considerations / Critical Inclusions</div>
          <table class="table table-striped bg-white table-sm">
            <tbody>
              <tr v-for="(consideration, index) in row.item.considerations" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td v-html="consideration"></td>
              </tr>
            </tbody>
          </table>
        </b-card>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>

  </div>
</template>

<script>
const items = [];
var moment = require("moment");
export default {
  props: ['competencies', 'user_role', 'current_user'],
  data() {
    return {
      moment: moment,
      items: this.competencies,
      user: this.current_user,
      role: this.user_role,
      fields: [
        { key: "competency", label: "Competency" },
        { key: "user", label: "Preceptor" },
        { key: "date", label: "Dates" },
        { key: "pass", label: "Evaluation", class: "text-center"},
        { key: "actions", label: "Action", class: "text-center" }
      ],
      filter: null,
      sortBy: "updated_at",
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      totalRows: this.competencies.length,
      pageOptions: [10, 20, 40, 50],
      warn: false,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    showFile(id) {
      window.location.href = ('/instructor/competency/file/download/' + id);
    },
    viewComp(id) {
      if (this.user_role == 'student') {
        window.location.href = ('/competency/assessed/show/' + id);
      } else {
        window.location.href = ('/competency/assessed/view/' + id);
      }
    },
    editComp(id) {
        window.location.href = ('/competency/review/' + id);     
    }
  }
};
</script>

<!-- table-complete-1.vue -->